import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { AppContext } from "@my-dld/contexts/AppContext";
import { Route, Switch } from "react-router";
import RTRegistration from "./RTRegistration";
import ProcedureSelection from "./ProcedureSelection";
import RTRegistrationContextWrapper from "@my-dld/contexts/RTRegistrationContext";

class RTOnlineReg extends Component<RoutedViewProps> {
	static contextType = AppContext;
	context!: React.ContextType<typeof AppContext>;

	render() {
		const pp = this.props.match.url;
		return <RTRegistrationContextWrapper>
			<Switch>
				<Route path={ pp + "/procedure/:tabuPropertyId" } component={ ProcedureSelection }/>
				<Route path={ pp + "/registration" } component={ RTRegistration }/>
			</Switch>
		</RTRegistrationContextWrapper>;
	}
}

export default RTOnlineReg;
